export default __webpack_public_path__ + "static/IN-8015HD_Quick-Installation_P2P-WPS_04-e83bcaf4339cc2d4eb4e80b138ac6c8b.webp";